<div class="login-body">
    <div class="login-panel p-fluid">
        <p-messages [(value)]="errorMessages" [closable]="false"></p-messages>
        <div class="p-grid login-container" style="padding-bottom: 20px;">
            <div class="p-col-12 logo-container">
                <img src="assets/title_logo.png" class="morpheus-logo" />
            </div>
            <div class="p-col-12">
                <input type="text" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="registrationUser.name"
                    placeholder="Name">
            </div>
            <div class="p-col-12">
                <input type="email" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="registrationUser.email"
                    placeholder="Email">
            </div>
            <div class="p-col-12">
                <input type="password" autocomplete="off" class="p-inputtext p-corner-all p-state-default p-widget" [(ngModel)]="registrationUser.password"
                    placeholder="Password">
            </div>
            <div class="p-col-12 button-container">
                <button type="button" (click)="onRegister()" class="p-button blue-btn raised-btn p-widget p-state-default p-corner-all p-button-text-icon-left">
                        <span class="p-button-icon-left p-c fa fa-fw fa-user"></span>
                        <span class="p-button-text p-c">Register</span>
                </button>
            </div>
        </div>
        <div class="stripe"></div>
        <p style="margin-left: -17px;">Already have an account? <a [routerLink]="['/login']"> Sign in here </a></p>
        <div class="stripe"></div>
    </div>
</div>
